<template>
    <div>
        <v-dialog
            overlay-color="white"
            width="800px">
            <template v-slot:activator="{ on, attrs }">
                <div
                    v-bind="attrs"
                    v-on="on"
                    class="list-tooltip"
                    style="vertical-align: text-bottom; display: inline">
                    <slot name="modal-trigger"></slot>
                </div>
            </template>
            <v-card>
                <v-card-title>{{ title }}</v-card-title>
                <v-card-text><slot name="modal-content"></slot></v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        }
    }
}
</script>
